import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
    '4d9d42afeebad60c91e676e008fadab0Tz0xMjE1MjcsRT0xNzk0MDk1OTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI='
);